<template>
  <div>
    <v-row class="pl-2 pr-2">
      <v-col cols="12" md="4" order="1" order-md="1" class="mb-4 mb-md-0">
        <list-card />
      </v-col>
      <v-col cols="12" md="4" order="2" order-md="2" class="mb-4 mb-md-0">
        <time-line-with-icon />
      </v-col>
      <v-col cols="12" md="4" order="3" order-md="3">
        <v-card style="height: 700px;">
          <v-card-title>
            Pré visualização
            <v-spacer></v-spacer>
            <v-switch v-model="speed" label="Rápido" hide-details style="margin-top:-5px">
            </v-switch>
          </v-card-title>
          <v-alert v-model="alerta" dismissible dense outlined prominent elevation="2" transition="scale-transition" type="warning">
            Ao ativar o modo rápido o tempo total percorrido será aproximado dependendo do desempenho do seu computados. Tenha esse resultado apenas como estimativa.
          </v-alert>
          <v-card-title>
            <v-btn-toggle tile group color="dark">
              <v-btn title="Voltar uma notícia/anúncio" small fab color="dark" @click="backItem"
                :disabled="buttonsDisabled">
                <v-icon dark>mdi-skip-backward</v-icon>
              </v-btn>
              <v-btn title="Voltar um template" small fab color="dark"
                @click="$store.commit('templates/toggleBackTemplate')" :disabled="buttonsDisabled">
                <v-icon dark>mdi-chevron-double-left</v-icon>
              </v-btn>
              <v-btn title="Play / Pause" small fab color="dark" @click="togglePlayPause" :disabled="buttonsDisabled">
                <v-icon dark>{{ iconPlayAndPause }}</v-icon>
              </v-btn>
              <v-btn title="Reniciar" small fab color="dark" @click="buttonRestart" :disabled="buttonsDisabled">
                <v-icon dark>mdi-reload</v-icon>
              </v-btn>
              <v-btn title="Próximmo template" small fab color="dark"
                @click="$store.commit('templates/toggleNextTemplate')" :disabled="buttonsDisabled">
                <v-icon dark>mdi-chevron-double-right</v-icon>
              </v-btn>
              <v-btn title="Próxima notícia/anúncio" small fab color="dark" @click="nextItem"
                :disabled="buttonsDisabled">
                <v-icon dark>mdi-skip-forward</v-icon>
              </v-btn>
            </v-btn-toggle>
            <v-spacer></v-spacer>
            {{ time }}
            <!-- <v-btn small color="primary">Templates</v-btn> -->
          </v-card-title>

          <div v-if="notRestarted">
            <PreviewOld v-if="$store.state.playlist.showPreviewOld && !forceShowPreviwAds" />
            <PreviewNews @play="buttonPlay" @stop="endNews"
              v-if="itemType === 'Notícia' && !$store.state.playlist.showPreviewOld && !forceShowPreviwAds" />
            <PreviewAds v-if="(itemType === 'Anúncio' || forceShowPreviwAds) && !$store.state.playlist.showPreviewOld"
              @end="endAds" :onPlay="onPlay" />
          </div>
        </v-card>
      </v-col>
      <!-- <v-col md="4" v-if="false"><time-line-with-icon  class="elevation-5"/></v-col> -->
    </v-row>
    <v-row>
      <v-col cols="12" md="4" class="ml-md-auto">
        <table class="summary-table">
          <tr>
            <th>Parceiro</th>
            <th>Total</th>
          </tr>
          <tr v-for="item, index in items" :key="index">
            <td>{{ item.name }}</td>
            <td>{{ item.qtd }}</td>
          </tr>
          <tr>
            <th colspan="2">Total: {{ total }}</th>
          </tr>
        </table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import TimeLineWithIcon from './TimelineNews.vue';
import ListCard from './ListCard.vue';
import PreviewNews from './previewNews'
import PreviewAds from './previewAds'
import PreviewOld from './previewNewsOld.vue'
import _ from 'lodash'
// @ is an alias to /src
export default {
  name: "Schedules",
  components: { TimeLineWithIcon, ListCard, PreviewNews, PreviewAds, PreviewOld },
  data() {
    return {
      alerta: false,
      
      desserts: [],
      items: [],
      total: 0,
      iconPlayAndPause: "mdi-play",
      onPlay: false,
      dateTime: new Date("1997-01-01 00:00:00"),
      notRestarted: true,
      time: "00:00:00",
      playIndex: 0,
      buttonsDisabled: true,
      restarter: false
    }
  },
  computed: {
    speed: {
      get(){
        return this.$store.state.previews.speed
      },
      set(v){
        if(v){
        if(!window.localStorage.getItem('ALERTA_RAPIDO')) this.alerta = true
        this.$store.commit('previews/speed')
      }else{
        this.$store.commit('previews/normal')
      }
      this.buttonRestart()
      }
    },
    itemType() {
      return this.$store.state.playlist.itemsSelected[this.$store.state.playlist.playIndex]?.itemType
    },
    forceShowPreviwAds() {
      return this.$store.state.playlist.showPreviewAds
    }
  },
  methods: {
    backItem() {
      this.$store.state.playlist.playIndex = (this.$store.state.playlist.playIndex - 1) <= 0 ? 0 : this.$store.state.playlist.playIndex - 1
    },
    nextItem() {
      if (this.$store.state.playlist.itemsSelected[this.$store.state.playlist.playIndex + 1]?._id === '1133'
        || !this.$store.state.playlist.itemsSelected[this.$store.state.playlist.playIndex + 1]?._id) {
        return;
      }
      this.$store.state.playlist.playIndex += 1
    },
    endAds() {
      const next = this.$store.state.playlist.playIndex + 1
      if (!this.$store.state.playlist.itemsSelected[next] || this.$store.state.playlist.itemsSelected[next]?._id === '1133') {
        return this.buttonPause()
      }
      this.$store.state.playlist.playIndex = this.$store.state.playlist.playIndex + 1
    },
    endNews() {
      this.buttonPause()
      this.restarter = true
    },
    buttonRestart() {
      if (!this.items.length) {
        return this.buttonPause()
      }
      clearInterval(this.interval)
      this.$store.state.playlist.playIndex = 0
      this.resetTimer()
      this.$store.commit('playlist/showPreviewAds', false)
      this.onPlay = false
      this.notRestarted = false
      this.$nextTick(() => {
        this.notRestarted = true
        this.buttonPlay()
        this.$store.commit('playlist/setPreviewOld', false)
      })
    },
    buttonPause() {
      this.$store.commit('playlist/showPreviewAds', false)
      this.onPlay = false
      clearInterval(this.interval)
      this.iconPlayAndPause = "mdi-play"
      this.$store.commit("previews/togglePlay", false)
    },
    resetTimer() {
      this.time = "00:00:00"
      this.dateTime = new Date("1997-01-01 00:00:00")
    },
    buttonPlay() {
      if (this.restarter) {
        this.restarter = false;
        return this.buttonRestart()
      }
      this.onPlay = true
      //this.$store.state.playlist.playIndex = 0
      //this.time = "00:00:00"
      //this.dateTime = new Date("1997-01-01 00:00:00")
      //this.notRestarted = false
      //this.$nextTick(() => this.notRestarted = true)

      this.iconPlayAndPause = "mdi-pause"
      this.$store.commit("previews/togglePlay", true)
      clearInterval(this.interval)
      this.interval = setInterval(() => {
        this.dateTime.setSeconds(this.dateTime.getSeconds() + 1)
        const hours = String(this.dateTime.getHours()).padStart(2, '0');
        const min = String(this.dateTime.getMinutes()).padStart(2, '0');
        const sec = String(this.dateTime.getSeconds()).padStart(2, '0');
        this.time = `${hours}:${min}:${sec}`
      }, this.$store.state.previews.timeout);
    },
    togglePlayPause() {
      if (this.iconPlayAndPause === "mdi-play") {
        this.buttonPlay()
        this.$store.commit('playlist/setPreviewOld', false)
      } else {
        this.buttonPause()
      }
    },
  },
  beforeDestroy() {
    this.$store.state.playlist.showPreviewOld = true
  },
  mounted() {
    this.$store.state.playlist.showPreviewOld = false
    //this.$store.commit("previews/speed")
  },
  watch: {
    "$store.state.playlist.showPreviewOld"(value){
      if(value)this.buttonPause()
    },
    "$store.state.playlist.itemsSelected"(items) {

      this.$store.state.playlist.showPreviewOld = false
      const newItems = items.filter(item => item._id !== '1133').map(item => ({ name: item.user.name, qtd: 1 }))
      this.buttonsDisabled = !newItems.length
      this.items = _(newItems).groupBy("name").map((group, name) => ({ name, qtd: _.sumBy(group, 'qtd') })).value()
      this.total = this.items.reduce((acc, item) => acc += item.qtd, 0)
      this.buttonRestart()
    },
    "alerta"(v){
      if(v){
        window.localStorage.setItem("ALERTA_RAPIDO", '1')
      }
    },

  }
};
</script>

<style scoped>
table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

tr:nth-child(even) {
  background-color: #dddddd;
}

.summary-table {
  max-width: 420px;
  margin-left: auto;
}
</style>
